/* Define our mutations and register our store */
import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// initial state
const state = {
  added: [],
  token: null,
  user: null,
  isUserLoggedIn: false,
  currentCategory: null,
  currentItem: null,
  currentFilterTag: null,
  cartAmount: null,
  stripeToken: null,
  tableNumber: null,
  stripeConnectUserId: null
  /* ,
  printerLanguage: null */
}

// getters
const getters = {
  cartItems: (state) => {
    return state.added
  },
  isUserLoggedIn: (state) => {
    return state.isUserLoggedIn
  },
  user: (state) => {
    return state.user
  },
  currentCategory: (state) => {
    return state.currentCategory
  },
  currentItem: (state) => {
    return state.currentItem
  },
  currentFilterTag: (state) => {
    return state.currentFilterTag
  },
  cartAmount: (state) => {
    return state.cartAmount
  },
  stripeToken: (state) => {
    return state.stripeToken
  },
  tableNumber: (state) => {
    return state.tableNumber
  },
  stripeConnectUserId: (state) => {
    return state.stripeConnectUserId
  }
  /* ,
  printerLanguage: (state) => {
    return state.printerLanguage
  } */
}

// actions
const actions = {
  addToCart ({ commit }, item) {
    commit(types.ADD_TO_CART, {
      _id: item._id,
      name: item.name,
      price: item.price,
      currency: item.currency,
      category: item.category,
      variant: item.variant,
      extras: item.extras,
      style: item.style
    })
  },
  removeFromCart ({ commit }, item) {
    commit(types.REMOVE_FROM_CART, {
      _id: item._id,
      extras: item.extras,
      style: item.style,
      quantity: item.quantity
    })
  },
  clearCart ({ commit }) {
    commit(types.CLEAR_CART)
  },
  setToken ({ commit }, token) {
    commit(types.SET_TOKEN, token)
  },
  setUser ({ commit }, user) {
    commit(types.SET_USER, user)
  },
  fetchLocalStorage ({ commit }) {
    const smartdineLocalStorage = JSON.parse(
      window.localStorage.getItem('smartdine')
    )
    if (smartdineLocalStorage) {
      const added = smartdineLocalStorage.added
      const token = smartdineLocalStorage.token
      const user = smartdineLocalStorage.user
      commit(types.FETCH_LOCAL_STORAGE, {
        added,
        token,
        user
      })
    }
  },
  setCurrentCategory ({ commit }, category) {
    commit(types.SET_CURRENT_CATEGORY, category)
  },
  setCurrentItem ({ commit }, item) {
    commit(types.SET_CURRENT_ITEM, item)
  },
  setCurrentFilterTag ({ commit }, filtertag) {
    commit(types.SET_CURRENT_FILTERTAG, filtertag)
  },
  setCartAmount ({ commit }, amount) {
    commit(types.SET_CART_AMOUNT, amount)
  },
  setStripeToken ({ commit }, token) {
    commit(types.SET_STRIPE_TOKEN, token)
  },
  setTableNumber ({ commit }, tableNumber) {
    commit(types.SET_TABLE_NUMBER, tableNumber)
  },
  setStripeConnectUserId ({ commit }, stripeConnectUserId) {
    commit(types.SET_STRIPE_CONNECT_USER_ID, stripeConnectUserId)
  }
  /* ,
  setPrinterLanguage ({ commit }, printerLanguage) {
    commit(types.SET_PRINTER_LANGUAGE, printerLanguage)
  } */
}

// mutations
const mutations = {
  [types.ADD_TO_CART] (
    state,
    { _id, name, price, currency, category, variant, extras, style }
  ) {
    let record = null

    // find all the records with same id
    const existingRecords = state.added.filter((i) => i._id === _id)
    if (existingRecords.length > 0) {
      // check for same style
      let matchedStyleRecord = existingRecords.filter((r) => r.style === style)
      if (matchedStyleRecord) {
        matchedStyleRecord.forEach((msr) => {
          // compare both 'extras' arrays
          if (JSON.stringify(msr.extras) === JSON.stringify(extras)) {
            record = msr
          }
        })
      }
    }

    if (!record) {
      state.added.push({
        _id,
        name,
        price,
        currency,
        category,
        variant,
        extras,
        style,
        quantity: 1
      })
    } else {
      record.quantity++
    }
  },

  [types.REMOVE_FROM_CART] (state, { _id, extras, style, quantity }) {
    let record = null
    // find all the records with same id
    const existingRecords = state.added.filter((i) => i._id === _id)
    if (existingRecords.length > 0) {
      // check for same style
      let matchedStyleRecord = existingRecords.filter((r) => r.style === style)
      if (matchedStyleRecord) {
        matchedStyleRecord.forEach((msr) => {
          // compare both 'extras' arrays
          if (JSON.stringify(msr.extras) === JSON.stringify(extras)) {
            record = msr
          }
        })
      }
    }

    if (quantity > 1) {
      record.quantity--
    } else {
      state.added.splice(state.added.indexOf(record), 1)
    }
  },

  [types.CLEAR_CART] (state) {
    state.added = []
  },

  [types.SET_TOKEN] (state, token) {
    state.token = token
    if (token) {
      state.isUserLoggedIn = true
    } else {
      state.isUserLoggedIn = false
    }
  },

  [types.SET_USER] (state, user) {
    state.user = user
  },

  [types.FETCH_LOCAL_STORAGE] (state, { added, token, user }) {
    state.added = added
    state.token = token
    state.user = user
    if (token) {
      state.isUserLoggedIn = true
    } else {
      state.isUserLoggedIn = false
    }
  },

  [types.SET_CURRENT_CATEGORY] (state, category) {
    state.currentCategory = category
  },

  [types.SET_CURRENT_ITEM] (state, item) {
    state.currentItem = item
  },

  [types.SET_CURRENT_FILTERTAG] (state, filtertag) {
    state.currentFilterTag = filtertag
  },

  [types.SET_CART_AMOUNT] (state, amount) {
    state.cartAmount = amount
  },

  [types.SET_STRIPE_TOKEN] (state, token) {
    state.stripeToken = token
  },

  [types.SET_TABLE_NUMBER] (state, tableNumber) {
    state.tableNumber = tableNumber
  },

  [types.SET_STRIPE_CONNECT_USER_ID] (state, stripeConnectUserId) {
    state.stripeConnectUserId = stripeConnectUserId
  }
  /* ,

  [types.SET_PRINTER_LANGUAGE] (state, printerLanguage) {
    state.printerLanguage = printerLanguage
  } */
}

// Local Storage
const vuexLocal = new VuexPersistence({
  key: 'smartdine',
  reducer: (state) => ({
    user: state.user,
    token: state.token,
    added: state.added,
    tableNumber: state.tableNumber,
    stripeConnectUserId: state.stripeConnectUserId
  }),
  storage: window.localStorage
})

// one store for entire application
export default new Vuex.Store({
  state,
  strict: false,
  getters,
  actions,
  mutations,
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js